// extracted by mini-css-extract-plugin
export default {"header":"ProductRecalls_header__SCMsm","data_error":"ProductRecalls_data_error__YEVYB","no_data_img":"ProductRecalls_no_data_img__-n7Dw"};